module.exports = __webpack_public_path__ + "media/src/images/icons/cross_light-8304997c415d9e0e0db5395f56465a5f.svg";